"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addClass = addClass;
exports.hasClass = hasClass;
exports.removeClass = removeClass;
function hasClass(el, className) {
  if (!el || !className) {
    return false;
  }
  if (el.classList) {
    return el.classList.contains(className);
  }
  return " ".concat(el.className, " ").indexOf(" ".concat(className, " ")) > -1;
}
function addClass(el, className) {
  if (!el) return;
  var curClass = el.className;
  var classes = (className || '').split(' ');
  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    // eslint-disable-next-line no-continue
    if (!clsName) continue;
    if (el.classList) {
      el.classList.add(clsName);
    } else if (!hasClass(el, clsName)) {
      curClass += " ".concat(clsName);
    }
  }
  if (!el.classList) {
    // eslint-disable-next-line no-param-reassign
    el.className = curClass;
  }
}
function removeClass(el, className) {
  if (!el || !className) return;
  var classes = className.split(' ');
  var curClass = " ".concat(el.className, " ");
  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    // eslint-disable-next-line no-continue
    if (!clsName) continue;
    if (el.classList) {
      el.classList.remove(clsName);
    } else if (hasClass(el, clsName)) {
      curClass = curClass.replace(" ".concat(clsName, " "), ' ');
    }
  }
  if (!el.classList) {
    // eslint-disable-next-line no-param-reassign
    el.className = curClass.trim();
  }
}